var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"option-card"},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":_vm.icon}}),_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('a',{staticClass:"close",on:{"click":_vm.close}},[_vm._v("×")])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b4b9d2a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/record-details/OptionCard.vue
// module id = null
// module chunks = 